import React from "react";
import { formatNumber } from "@/utils/numbers";
import Text from "@/components/ui/text";
import { Column } from "@/pages/deals/components/KanbanBoard/KanbanBoard";
import { Minimize } from "@dreamhub/designsystem/icons";
import { getColorForMilestoneByType } from "@/components/shared/Milestones";
import IconContainer from "@/components/ui/icon-container";
import Spinner from "@/components/ui/spinner";
import Badge from "@/components/ui/badge";

interface Props extends Omit<Column, "items"> {
  arrMrr: number;
  deals: number;
  isLoading: boolean;
  onMinimizeColumn: (columnId: number) => void;
}

const StageCard: React.FC<Props> = ({
  arrMrr,
  milestone,
  id,
  title,
  deals,
  isLoading,
  onMinimizeColumn
}) => {
  const { value, currencySign } = formatNumber(arrMrr, 0, true, false);

  const Loading = <Spinner size="5" />;

  return (
    <div
      data-test={`milestone-${milestone}-stage-${id}`}
      className="group w-full mb-4 flex p-2 rounded-xl cursor-pointer justify-between"
      style={{
        backgroundColor: getColorForMilestoneByType(milestone, "background")
      }}
      onClick={() => onMinimizeColumn(id)}
    >
      <div className="flex gap-[14px] items-center min-w-0 flex-1">
        <div
          className="w-[5px] h-6 rounded flex-shrink-0"
          style={{
            backgroundColor: getColorForMilestoneByType(milestone, "border")
          }}
        />
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <Text
            data-test={`stage-${id}-title`}
            as="div"
            variant="lgLabel"
            className="truncate"
          >
            {title}
          </Text>
          {!isLoading && (
            <Badge
              text={deals?.toString()}
              className="py-[1px] px-[3px] min-w-[22px] bg-badges-on-color flex-shrink-0"
              textVariant="smBody"
            />
          )}
        </div>
      </div>
      <div className="flex items-center relative overflow-hidden">
        <div className="transition-transform duration-200 translate-x-0 group-hover:-translate-x-full">
          {isLoading ? (
            Loading
          ) : (
            <span>
              <Text as="span" variant="lgLabel">
                {currencySign}
              </Text>
              <Text
                data-test={`stage-${id}-mrr-value`}
                as="span"
                variant="lgLabel"
              >
                {value}
              </Text>
            </span>
          )}
        </div>
        <div className="absolute right-0 inset-y-0 flex items-center transition-transform duration-200 translate-x-full group-hover:translate-x-0">
          <IconContainer size="5">
            <Minimize />
          </IconContainer>
        </div>
      </div>
    </div>
  );
};

export default StageCard;
